module.exports = __webpack_public_path__ + "img/icon_seragam.72c77a4e.svg";